"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=useUniqueIdentifier;var _react=require("react");var idCounter=0;function useUniqueIdentifier(prefix){return(0,_react.useMemo)(function(){idCounter+=1;return prefix?"".concat(prefix,"-").concat(idCounter):String(idCounter);},[prefix]);}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rainbow-modules/hooks/lib/useUniqueIdentifier.js
// module id = VPtb
// module chunks = 0